<ew-mat-dialog-custom>
  <ew-mat-stepper-custom textForSendButton="shared:edit" [validations]="validations" [sendIn]="'penultimate'"
    [error]="errors" [showLogo]="false" (send)="updateBankAccount()">
    <ew-mat-stepper-custom-step>
      <div class="text-center grid gap-4 max-w-2xl">
        <div class="my-3 text-5xl font-bold">
          {{ 'updateBankAccount:editAccountTitle' | translate }}
        </div>

        <form class="grid gap-2" [formGroup]="form">
          <div class="w-full grid grid-cols-1 gap-4">
            <mat-form-field>
              <mat-label>
                {{ 'createBankAccount:alias' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input matInput type="text" id="alias" [formControlName]="'alias'" required />
              <mat-error *ngIf="controls['alias'].errors">
                <span *ngIf="controls['alias'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>
                <span *ngIf="controls['alias'].errors['minlength']">
                  {{ controls['alias'].errors['minlength'] | errorMinValue }}
                </span>
                <span *ngIf="controls['alias'].errors['maxlength']">
                  {{ controls['alias'].errors['maxlength'] | errorMaxValue }}
                </span>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="w-full grid grid-cols-1 gap-4 text-left">
            <div class="mb-2">
              <div class="text-sm font-medium text-gray-500 mb-1">
                {{ 'createBankAccount:beneficiary' | translate }}
              </div>
              <div class="text-base">{{ data.bankAccount.bankAccount.payee_name }}</div>
            </div>

            <div class="mb-2">
              <div class="text-sm font-medium text-gray-500 mb-1">
                {{ 'createBankAccount:inputCountry' | translate }}
              </div>
              <div class="text-base">{{ 'country:' + data.bankAccount.bankAccount.country.toUpperCase() | translate }}
              </div>
            </div>

            <div class="mb-2">
              <div class="text-sm font-medium text-gray-500 mb-1">
                {{ 'createBankAccount:inputCurrency' | translate }}
              </div>
              <div class="flex items-center">
                <img class="w-6 h-6 rounded-full mr-2"
                  [src]="'https://flagcdn.com/' + (data.bankAccount.bankAccount.currency | currencyCountry) + '.svg'"
                  [alt]="data.bankAccount.bankAccount.currency" />
                <span>{{ data.bankAccount.bankAccount.currency }} | {{ 'currencyName:' +
                  data.bankAccount.bankAccount.currency | translate }}</span>
              </div>
            </div>

            <div class="mb-2">
              <div class="text-sm font-medium text-gray-500 mb-1">
                {{ 'createBankAccount:inputBankName' | translate }}
              </div>
              <div class="text-base">{{ data.bankAccount.bankAccount.bank_name }}</div>
            </div>

            <div class="mb-2">
              <div class="text-sm font-medium text-gray-500 mb-1">
                {{ 'createBankAccount:inputBankBranchAddress' | translate }}
              </div>
              <div class="text-base">{{ data.bankAccount.bankAccount.address }}</div>
            </div>

            <div class="mb-2">
              <div class="text-sm font-medium text-gray-500 mb-1">
                {{ 'createBankAccount:inputAccountNumber' | translate }}
              </div>
              <div class="text-base">{{ data.bankAccount.bankAccount.accountNumber | maskAccountNumber }}</div>
            </div>

            <div class="mb-2">
              <div class="text-sm font-medium text-gray-500 mb-1">
                {{ 'createBankAccount:status' | translate }}
              </div>
              <div class="text-base">{{ 'bankAccounts:status' + data.bankAccount.bankAccount.status.toUpperCase() |
                translate }}</div>
            </div>
          </div>
        </form>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <mat-progress-spinner class="m-auto my-5" [diameter]="24" [mode]="'indeterminate'"
        *ngIf="loading"></mat-progress-spinner>

      <div class="text-center grid gap-4 max-w-2xl" *ngIf="!loading && success">
        <img class="w-10 m-auto mt-10" width="150" src="assets/circle-check.svg" alt="" />
        <div class="mb-5 text-5xl font-bold">
          {{ 'updateBankAccount:updateSuccessful' | translate }}
        </div>
      </div>

      <div class="text-center grid gap-4 max-w-2xl" *ngIf="!loading && !success">
        <img class="w-10 m-auto" width="150" src="assets/circle-error.svg" alt="" />
        <div class="mb-5 text-5xl font-bold">
          {{ 'updateBankAccount:statusErrorTitle' | translate }}
        </div>
        <div>
          {{ 'updateBankAccount:statusErrorSubtitle' | translate }}
        </div>
        <treo-message *ngIf="errors" [appearance]="'outline'" [showIcon]="false" [showButtonClose]="false"
          [type]="'error'" [@shake]="true">
          <ul class="list-disc pl-3 text-left" *ngIf="errors">
            <li *ngFor="let item of errors">{{ item }}</li>
          </ul>
        </treo-message>
      </div>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>